import { css, keyframes } from "@emotion/react";
import styled from "@emotion/styled";

// Mobile menu
const backgroundWidth = `300vw`;
const backgroundHeight = `300vh`;

const openKeyframe = keyframes`
  from {
    height: 0;
    width: 0;
  }

  to {
    height: ${backgroundHeight};
    width: ${backgroundWidth};
  }
`;

export const MenuBackground = styled("div", {
  shouldForwardProp: (prop) => prop !== "open" && prop !== "reversePosition",
})<{
  open: boolean;
  reversePosition?: boolean;
}>`
  position: fixed;
  top: 0px;

  ${({ reversePosition }) =>
    reversePosition
      ? css`
          left: 0px;
        `
      : css`
          right: 0px;
        `}

  right: 0px;
  background-color: white;
  border: 1px sold rgba(0, 0, 0, 0.4);
  border-radius: 9999px;

  ${({ reversePosition }) => {
    const transformValue = reversePosition
      ? `calc(-${backgroundWidth} / 2)`
      : `calc(${backgroundWidth} / 2)`;
    return css`
      transform: translate(${transformValue}, calc(-${backgroundHeight} / 2));
    `;
  }}
  height: 0;
  width: 0;

  ${({ open }) =>
    open &&
    css`
      animation: ${openKeyframe} 0.75s;
      display: flex;
      height: ${backgroundHeight};
      width: ${backgroundWidth};
      z-index: 5;
    `}
`;
